import * as React from "react";

const SvgIcnLineBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M20.907 12.063a6.018 6.018 0 01-.687 1.97c-.161.29-.95 1.394-1.191 1.686-1.33 1.6-3.555 3.448-7.276 5.244a.49.49 0 01-.7-.494l.187-1.688a.489.489 0 00-.434-.54c-4.405-.462-7.805-3.46-7.805-7.089 0-3.948 4.025-7.15 8.99-7.15 4.824 0 8.76 3.024 8.978 6.818.007.11.024.462.009.699-.01.143-.03.326-.071.544zm-13.86.538V9.589a.46.46 0 00-.92 0v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38zm2.837.92a.36.36 0 00.359-.36V9.488a.36.36 0 00-.36-.359h-.2a.36.36 0 00-.36.36v3.672c0 .198.161.36.36.36h.2zm3.715-3.932v2.12s-1.836-2.394-1.864-2.426a.458.458 0 00-.36-.154.472.472 0 00-.442.479v3.452a.46.46 0 00.92 0v-2.108s1.863 2.416 1.89 2.442c.082.077.191.125.312.126.255.002.464-.223.464-.479V9.59a.46.46 0 00-.92 0zm4.368 0a.46.46 0 00-.46-.46h-1.839a.46.46 0 00-.46.46v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38v-.816h1.38a.46.46 0 000-.92h-1.38v-.815h1.38a.46.46 0 00.46-.46z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnLineBold;
